import Div from "@jumbo/shared/Div/Div";
import {
  Modal,
  Card,
  CardContent,
  Typography,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

const ErrorPreview = ({ isModalOpen, handleModalClose, errorMessage }) => {
  const [isErrorMessage, setIsErrorMessage] = useState([]);

  useEffect(() => {
    // Parse the errorMessage JSON string
    const jsonError = JSON.parse(errorMessage);
    setIsErrorMessage(jsonError);
  }, [errorMessage]);

  return (
    <Modal
      open={isModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          maxWidth: "700px",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          p: "20px",
        }}
        variant="outlined"
      >
        <CardContent
          sx={{
            height: "100%",
            overflow: "auto",
          }}
        >
          <Typography variant="h6">Error Details</Typography>
          {isErrorMessage?.map((message, index) => (
            <div key={index} style={{ marginTop: "10px" }}>
              <div style={{ fontWeight: "bold" }}>
                Row No: {Object.keys(message)[0]}
              </div>
              <div>Error: {message[Object.keys(message)[0]]}</div>
            </div>
          ))}
        </CardContent>
        <IconButton
          style={{ position: "absolute", top: "15px", right: "40px", background:"#D3D3D3",padding:"none",height:"25px", width:"25px" }}
          onClick={handleModalClose}
        >
          <CloseIcon style={{ height:"15px", width:"15px",}}/>
        </IconButton>
      </Card>
    </Modal>
  );
};

export default ErrorPreview;
